export default __webpack_public_path__ + "static/media/NEW_DAX_LOGO.cde46107.png";